import { Create, SimpleForm, required } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import { WordleLettersInput } from '../../../../commonComponents/WordleLettersInput';

const WordleEventsCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <CustomDateInput label="Date" source="date" validate={required()} />
      <WordleLettersInput source="letters" label="Letters" validate={required()} />
    </SimpleForm>
  </Create>
);

export default WordleEventsCreate;
